<template>
    <div class="certificate-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="pass-wrap"
             v-if="doctorMessage.authenticationStatus === 2">
            <i class="el-icon-success"></i>
            <span class="pass-text">认证通过</span>
        </div>
        <div class="refuse-wrap"
             v-if="doctorMessage.authenticationStatus === 3">
            <i class="el-icon-error"></i>
            <span class="refuse-text">认证不通过</span>

            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
                <span class="reason-text">原因：{{ doctorMessage.reviewReason }} </span>
                <span slot="content">{{ doctorMessage.reviewReason }}</span>
            </el-tooltip>
        </div>
        <div class="doctorDetail-wrap"
             v-loading="loading">
            <div class="hospital-title">
                <div v-if="doctorMessage.authenticationStatus === 1" style="display:flex;align-items:center">
                    <div><i class="iconfont icon-tongyongbiaotiicon"></i><span>审核</span></div>
                    <div style="margin-left:20px">
                        <el-select v-model="identities" placeholder="请选择用户身份">
                            <el-option
                            v-for="item in identitieslist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div v-if="doctorMessage.authenticationStatus === 2 || doctorMessage.authenticationStatus === 3"><i class="iconfont icon-tongyongbiaotiicon"></i><span>认证详情</span></div>
            </div>
            <!-- 查看基本信息 -->
            <div class="doctorDetail-wrap-see">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="avtar-cover">
                                <img v-if="doctorMessage.accountHead"
                                     :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.accountHead"
                                     class="papers"
                                     @click="avartIn(doctorMessage.accountHead)">
                                <div v-else
                                     class="info-avart-none">
                                    <i class="iconfont icon-Avatar"></i>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">姓名:</div>
                                <div class="info-message">{{doctorMessage.accountName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">身份证号:</div>
                                <div class="info-message">{{doctorMessage.idCard || '暂无'}}</div>
                            </div>

                            <div class="base-info-wrap">
                                <div class="info-label">学历:</div>
                                <div class="info-message">{{doctorMessage.educationBackgroundName || '暂无'}}</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">性别:</div>
                                <div class="info-message">{{sex[doctorMessage.accountSex] || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">登录手机号:</div>
                                <div class="info-message">{{doctorMessage.phone || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-min">医院:</div>
                                <div class="info-message">{{doctorMessage.hospitalName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label info-label-min">医生集团:</div>
                                <div class="info-message">{{doctorMessage.groups || '暂无'}}</div>
                            </div>

                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-te">科室:</div>
                                <div class="info-message">{{doctorMessage.departName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap"
                                 style="margin-bottom:16px;">
                                <div class="info-label info-label-te">职称:</div>
                                <div class="info-message">{{doctorMessage.titleName || '暂无'}}</div>
                            </div>

                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap"
                                 v-if="accountNumberShow">
                                <div class="info-label">工号:</div>
                                <div class="info-message">{{doctorMessage.accountNumber || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap"
                                 style="margin-bottom:16px;">
                                <div class="info-label">教职:</div>
                                <div class="info-message">{{doctorMessage.educationName || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <div class="base-info-wrap"
                                 style="margin-bottom:16px;">
                                <div class="info-label">角色:</div>
                                <div class="info-message">{{doctorMessage.roles || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="base-info-wrap"
                         style="margin-bottom:16px;">
                        <div class="info-label info-label-min"
                             style="line-height:22px">简介:</div>
                        <div class="info-message-detail">
                            {{doctorMessage.doctorResume || '暂无'}}
                        </div>
                    </div>
                </div>
                <div class="doctor-cert-info">
                    <div class="info-title">认证信息</div>
                    <div class="info-cert-wrap">
                        <div class="info-cert-item">
                            <div class="info-label">身份证正面:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <el-image v-if="doctorMessage.idCardFront"
                                              class="papers"
                                              @click="toPreview(doctorMessage.idCardFront)"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.idCardFront"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无身份证正面</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">工作证或参会胸牌:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <el-image v-if="doctorMessage.otherCard"
                                              class="papers"
                                              @click="toPreview(doctorMessage.otherCard)"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.otherCard"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无工作证或参会胸牌</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">医师注册执业证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <el-image v-if="doctorMessage.medicalRegisterFirst"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.medicalRegisterFirst"
                                              class="papers"
                                              @click="toPreview(doctorMessage.medicalRegisterFirst)"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无</div>
                                </div>
                                <div class="pic-back">
                                    <el-image v-if="doctorMessage.medicalRegisterSecond"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+doctorMessage.medicalRegisterSecond"
                                              class="papers"
                                              @click="toPreview(doctorMessage.medicalRegisterSecond)"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">执业医师资格证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <el-image v-if="doctorMessage.medicalLicenseFirst"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.medicalLicenseFirst"
                                              class="papers"
                                              @click="toPreview(doctorMessage.medicalLicenseFirst)"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无</div>
                                </div>
                                <div class="pic-back">
                                    <el-image v-if="doctorMessage.medicalLicenseSecond"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+doctorMessage.medicalLicenseSecond"
                                              class="papers"
                                              @click="toPreview(doctorMessage.medicalLicenseSecond)"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">专业技术资格证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <el-image v-if="doctorMessage.techFirst"
                                              :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.techFirst"
                                              class="papers"
                                              @click="toPreview(doctorMessage.techFirst)"
                                              lazy>
                                    </el-image>
                                    <div v-else
                                         class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item"
                             style="margin-bottom: 10px;">
                            <div class="info-label">电子签名:</div>
                            <div class="info-message">
                                <el-image v-if="doctorMessage.signatureUrl"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ doctorMessage.signatureUrl"
                                          class="paper-sign"
                                          @click="toPreview(doctorMessage.signatureUrl)"
                                          lazy>
                                </el-image>
                                <div v-else>暂无</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 认证中 -->
        <div class="add-btn-bottom"
             v-if="doctorMessage.authenticationStatus === 1">
            <el-button type="warning"
                       size="small"
                       @click="handlePass">认证通过</el-button>
            <el-button type="warning"
                       size="small"
                       @click="handleRefuse">认证不通过</el-button>
        </div>

        <el-dialog :visible.sync="cropperPrewVisible"
                   :show-close="false"
                   top="30vh"
                   width="400px"
                   class="ww-pre-dialog">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="handleAvartClose">
                </el-image>
            </span>
            <img width="100%"
                 :src="'/ms-hoc-video/v1/image/download?fileName='+ imagePrewUrl"
                 v-if="imagePrewUrl" />
        </el-dialog>

        <el-dialog :visible.sync="reasonVisible"
                   top="20vh"
                   title="认证不通过"
                   width="560px"
                   :close-on-click-modal="false"
                   class="fail-dialog">
            <!-- 为了 取消 没选择 再打开 没有红色提醒 加了v-if -->
            <el-form :model="ruleForm"
                     v-if="reasonVisible"
                     ref="ruleForm"
                     class="fail-ruleForm"
                     v-loading="reasonFormLoading">
                <div style="line-height:14px;color:#666666;margin-bottom:20px">请选择不通过原因:</div>
                <el-form-item prop="reasonName"
                              :rules="[{ required: true, message: '请选择不通过原因', trigger: 'change' }]">
                    <el-checkbox-group v-model="ruleForm.reasonName">
                        <el-checkbox v-for="(item, index) in reasonList"
                                     :key="index"
                                     :label="item">{{ item }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item v-if="ruleForm.reasonName.indexOf('其他')!==-1"
                              prop="otherReason"
                              :rules="[{ required: true, message: '请输入备注', trigger: 'change' }]">
                    <el-input v-model.trim="ruleForm.otherReason"
                              size="small"
                              :style="{width: '510px'}"
                              maxlength="15"
                              show-word-limit
                              placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item style="padding-bottom: 20px; text-align:center;">
                    <el-button type="primary"
                               class="commit-btn"
                               @click="handleCommitReason">提交</el-button>
                    <el-button class="cancle-btn"
                               type="info"
                               @click="reasonVisible=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible"
                   :destroy-on-close="true"
                   :show-close="false"
                   width="600px"
                   @close="clearUrl"
                   class="ww-pre-dialog">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="clearUrl">
                </el-image>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getApplyIdByIncId, putDoctorApply } from '@/api/certification'
export default {
    name: 'certificateDetail',
    data () {
        return {
            identities:'',
            identitieslist:[
                {value:'doctor',label:'医生'},
                {value:'nurse',label:'护士/医技'},
                {value:'pharmacist',label:'药剂师'},
            ],
            loading: false,
            sex: {
                '0': '女',
                '1': '男',
                '2': '暂无'
            },
            ruleForm: {
                reasonName: [],
                otherReason: ''
            },
            dialogImageUrl: '', // 预览
            incId: this.$route.query.incId,
            doctorMessage: {},
            breadList: [],
            cropperPrewVisible: false,
            reasonVisible: false,
            reasonFormLoading: false,
            dialogVisible: false,
            imagePrewUrl: '', // 头像资源
            deleteUrl: require('../../../assets/imgs/delete.png'),
            reasonList: ['身份证无法识别', '身份证与本人信息不符', '医师注册执业证无法识别', '医师注册执业与本人信息不符', '执业医师资格证无法识别', '执业医师资格证与本人信息不符', '专业技术资格证无法识别', '专业技术资格证与本人信息不符', '工作证或参会胸牌无法识别', '工作证或参会胸牌与本人信息不符', '您的职称暂不符合平台要求', '您的个人信息不全', '其他']
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        // 判断是否展示工号
        accountNumberShow () {
            let show = false
            if (this.doctorMessage.hospitalId === '34') { // 本院医生-树兰医院 展示 8c1460d0f30349628f8d787f8380e4c1
                show = true
            } else {
                if (this.doctorMessage.authenticationStatus === 2) { // 审核通过
                    show = true
                }
            }
            return show
        }
    },
    methods: {
        async getApplyData () {
            this.loading = true
            const { results } = await getApplyIdByIncId(this.incId)
            this.doctorMessage = JSON.parse(JSON.stringify(results))
            this.handleSeeData(this.doctorMessage)
            this.loading = false
        },
        // 处理查看的信息
        handleSeeData (data) {
            // 科室名字
            if (data.departmentVO) {
                data.departName = data.departmentVO.groupName
            }
            // 集团
            if (data.groupVOs) {
                let group = data.groupVOs
                let arr = []
                for (let j in group) {
                    arr.push(group[j].groupName)
                }
                data.groups = arr.join(' | ')
            }
            // 角色
            if (data.roles) {
                let roles = data.roles
                let arr = []
                for (let j in roles) {
                    arr.push(roles[j].roleName)
                }
                data.roles = arr.join(' | ')
            }

            if (data.authenticationStatus === 1) {
                this.breadList = [{ label: '用户管理' }, { label: '认证审核', path: '/user/certificationList' }, { label: '审核' }]
            }
            if (data.authenticationStatus === 2 || data.authenticationStatus === 3) {
                this.breadList = [{ label: '用户管理' }, { label: '认证审核', path: '/user/certificationList' }, { label: '认证详情' }]
            }
        },
        // 审核通过
        async handlePass () {
            if(this.identities == ''){
                return this.$message.warning('请选择用户身份')
            }
             this.loading = true
            let params = {
                incId: this.incId,
                reviewId: this.userInfo.iuid,
                reviewName: this.userInfo.accountName,
                authenticationStatus: 2,
                identities:this.identities
            }
            const { state,subMsg } = await putDoctorApply(params)
              this.loading = false
            if (state === 200) {
                this.$message({
                    message: '审核通过！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.$router.push('/user/certificationList')
            }else{
                  this.$message({
                    message: subMsg,
                    customClass: 'hos-message--error',
                    iconClass: 'el-icon-error',
                    duration: '2000'
                })
            }
        },
        // 审核不通过
        handleRefuse () {
            this.reasonVisible = true
        },
        handleCommitReason () {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.handleCommitSave()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },

        async handleCommitSave () {
            let params = {
                incId: this.incId,
                reviewId: this.userInfo.iuid,
                reviewName: this.userInfo.accountName,
                authenticationStatus: 3
            }
            let reasonList = JSON.parse(JSON.stringify(this.ruleForm.reasonName))
            reasonList.forEach((item, index) => {
                if (item === '其他') {
                    reasonList.splice(index, 1)
                    reasonList.push(this.ruleForm.otherReason)
                }
            })
            params.reviewReason = reasonList.join(';')
            this.reasonFormLoading = true
            const { state } = await putDoctorApply(params)
            if (state === 200) {
                this.$message({
                    message: '审核不通过，请重新认证审核！',
                    customClass: 'hos-message--error',
                    iconClass: 'el-icon-error',
                    duration: '2000'
                })
                this.getApplyData()
                this.reasonVisible = false
            }
            this.reasonFormLoading = false
        },
        avartIn (accountHead) {
            this.imagePrewUrl = accountHead
            this.cropperPrewVisible = true
        },
        handleAvartClose () {
            this.cropperPrewVisible = false
        },
        toPreview (file) {
            let reg = new RegExp('ZIP')
            file = file.replace(reg, '')
            this.dialogImageUrl = '/ms-hoc-video/v1/image/download?fileName=' + file
            this.dialogVisible = true
        },
        clearUrl () {
            this.dialogImageUrl = ''
            this.dialogVisible = false
        }
    },
    mounted () {
        this.getApplyData()
    }
}
</script>

<style lang="scss" scoped>
.certificate-wrap-out {
    .pass-wrap {
        background: #ecfbfb;
        border: 1px solid #c6eaeb;
        border-radius: 3px;
        height: 36px;
        display: flex;
        align-items: center;
        .el-icon-success {
            margin: 0 10px;
            color: #4acfb1;
            font-size: 16px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
        }
    }
    .refuse-wrap {
        background: #fff4f2;
        border: 1px solid #f2d2ce;
        border-radius: 3px;
        height: 36px;
        display: flex;
        align-items: center;
        .el-icon-error {
            margin: 0 10px;
            color: #ec6a69;
            font-size: 16px;
        }
        .refuse-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ec6a69;
            letter-spacing: 0;
        }
        .reason-text {
            margin-left: 20px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ec6a69;
            letter-spacing: 0;
            display: inline-block;
            width: calc(100% - 150px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .doctorDetail-wrap {
        background: #ffffff;
        margin: 20px;
        padding: 20px 20px 0px 20px;
        overflow: hidden;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .hospital-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            display: flex;
            justify-content: space-between;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
            .title-edit {
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                    color: $icon-edit;
                }
                span {
                    margin-left: 6px;
                    color: $icon-text;
                    font-size: 12px;
                }
            }
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
        }
        .doctorDetail-wrap-see {
            .doctor-base-info {
                // padding-bottom: 20px;
                border-bottom: 1px solid #cccccc;
                padding-top: 20px;
                .base-info-wrap {
                    margin-bottom: 20px;
                    display: flex;
                    // align-items: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    line-height: 14px;
                    color: #333333;
                    .info-label {
                        margin-right: 20px;
                        width: 78px;
                        text-align: right;
                        color: #666666;
                    }
                    .info-label-min {
                        min-width: 78px;
                    }
                    .info-label-te {
                        width: 44px;
                    }
                    .info-label-big {
                        width: 88px;
                    }
                    .info-message-detail {
                        width: 60%;
                        min-width: 700px;
                        line-height: 22px;
                        // max-height: 88px;
                        word-break: break-all;
                        word-wrap: break-word;
                    }
                }
                .avtar-cover {
                    margin-bottom: 20px;
                    padding-left: 12px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0;
                    text-align: left;
                    line-height: 14px;
                    img {
                        display: block;
                        width: 120px;
                        height: 120px;
                        cursor: pointer;
                    }
                    .info-message {
                        height: 100px;
                        line-height: 100px;
                    }
                    .info-avart-none {
                        width: 120px;
                        height: 120px;
                        background: #dcdcdc;
                        position: relative;
                        i {
                            color: #ffffff;
                            font-size: 80px;
                            position: absolute;
                            left: 20px;
                            top: 52px;
                        }
                    }
                }
            }
            .doctor-cert-info {
                padding-top: 20px;
                padding-bottom: 20px;
                .info-cert-wrap {
                    padding-left: 13px;
                    .info-cert-item {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        line-height: 14px;
                        color: #333333;
                        margin-bottom: 20px;
                        display: flex;
                        .papers {
                            display: block;
                            width: 200px;
                            height: 134px;
                            border-radius: 3px;
                            cursor: pointer;
                        }
                        .paper-sign {
                            display: block;
                            width: 70px;
                            height: 70px;
                            border-radius: 0px;
                            cursor: pointer;
                        }
                        .info-label {
                            margin-right: 20px;
                            width: 120px;
                            text-align: right;
                            color: #666666;
                        }
                        .info-pic {
                            display: flex;
                            .pic-cover {
                                margin-right: 20px;
                            }
                        }
                    }
                    .info-cert-item:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
<style lang="scss">
.fail-dialog {
    .el-dialog__body {
        .fail-ruleForm {
            .el-form-item__content {
                line-height: 1;
            }
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
            }
            .el-textarea {
                .el-textarea__inner {
                    background: #ffffff;
                    border: 1px solid #dcdcdc;
                    border-radius: 3px;
                    width: 311px;
                    height: 160px;
                    padding: 5px 10px;
                }
            }
            .commit-btn {
                width: 120px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 4px;
                padding: 0;
            }
            .cancle-btn {
                margin-left: 16px;
                width: 120px;
                height: 32px;
                font-family: PingFang-SC-Regular;
                font-size: 14px;
                color: #666;
                letter-spacing: 4px;
                padding: 0;
                border: 1px solid #dbdbdb;
                background-color: #f5f5f5;
            }
            .el-checkbox-group {
                .el-checkbox {
                    margin-right: 0px;
                    margin-bottom: 20px;
                    width: 246px;
                    color: #333333;
                    line-height: 1 !important;
                }
                .el-checkbox:last-child {
                    margin-bottom: 0;
                }
                .el-checkbox:nth-child(odd) {
                    width: 274px;
                }
            }
        }
    }
}
</style>
